import { render } from "./ItemsValidationDialog.vue?vue&type=template&id=1d760590"
import script from "./ItemsValidationDialog.vue?vue&type=script&lang=js"
export * from "./ItemsValidationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__